import { useTranslation } from 'react-i18next'
import { useRxCollection } from 'rxdb-hooks'

import { LanguageSelect } from '~/components/language-select'
import { LinkButton } from '~/components/link-button'
import type { Card } from '~/db/types'
import { MobileBottomLayout } from '~/layout/mobile-bottom'
import { useSettingsStore } from '~/stores/settings'

export const LanguagesPage = () => {
  const learnLanguage = useSettingsStore(state => state.learnLanguage)
  const sourceLanguage = useSettingsStore(state => state.sourceLanguage)
  const { t } = useTranslation()
  const cardsCollection = useRxCollection<Card>('cards')

  return (
    <MobileBottomLayout>
      <LanguageSelect
        cardsCollection={cardsCollection}
        defaultLearnLanguage={learnLanguage}
        defaultSourceLanguage={sourceLanguage}
        navigateTo="/settings"
      />
      <LinkButton to="/settings" variant="outline">
        {t('Back')}
      </LinkButton>
    </MobileBottomLayout>
  )
}
